/* ==================================================================
   ABHINC RIB CONFIGURATOR · production asset
   Geometry loads from rib-geometry.json. Variant IDs and prices
   resolve at runtime from the store's /products/{handle}.js
   endpoints, so nothing here needs editing when prices change.
   Fallback prices below are used only if resolution fails.
   ================================================================== */
(function(){
'use strict';

const rootEl = document.getElementById('rib-configurator');
if(!rootEl) return;

let CFG = { shopify:false, handles:{} };
const cfgEl = document.getElementById('rib-config');
if(cfgEl){
  try{ CFG = JSON.parse(cfgEl.textContent); }catch(e){}
}

/* ---------------- CONFIG ---------------- */
const COLOURWAYS = {
  graphite: { label:'Graphite', hex:0x333333 },   /* 80% black */
  slate:    { label:'Slate',    hex:0xB8B8B8 },
  clay:     { label:'Clay',     hex:0xCD7033 },
  sage:     { label:'Sage',     hex:0x5E6C55 }
};
const SWATCH_CSS = { graphite:'#333333', slate:'#B8B8B8', clay:'#CD7033', sage:'#5E6C55' };
const DEFAULT_COLOUR = 'clay';
const ROOT_HEX = 0x1A1A1A;   /* 90% black */

const PITCH = 21;
const BASE_H = 12;
const SEAT_DROP = 3;   /* pieces drop 3mm into the base, seated between ribs */
function zSeat(){ return state.base !== 'none' ? BASE_H - SEAT_DROP : 0; }

const BASES = {
  none: { label:'No base', sub:'pieces stand alone', price:0, w:330, d:210, snap:false },
  S:    { label:'Small base', sub:'166 × 147 mm', price:25, w:166, d:147, snap:true, geo:'RIB_base_S' },
  L:    { label:'Large base', sub:'292 × 147 mm', price:35, w:292, d:147, snap:true, geo:'RIB_base_L' }
};

const COASTER = { name:'RIB Coaster', price:10, fp:{w:105,d:105}, h:12, geo:'RIB_cpaster' };
const COASTER_RISE = 9;   /* coasters nest 3mm into each other */

const ROOT = {
  S:{ price:3, geo:'RIB_root_S' },
  M:{ price:6, geo:'RIB_root_M' },
  L:{ price:9, geo:'RIB_root_L' }
};

const PIECES = {
  cup: {
    name:'RIB Cup',
    sizes:{
      S:{ price:9,  fp:{w:63,d:63}, h:29.2, geo:'RIB_cup_S' },
      M:{ price:12, fp:{w:63,d:63}, h:55.5, geo:'RIB_cup_M' },
      L:{ price:15, fp:{w:63,d:63}, h:108,  geo:'RIB_cup_L' }
    },
    rootable:true
  },
  dish: {
    name:'RIB Dish',
    sizes:{
      S:{ price:9,  fp:{w:83,d:84},  h:15.5, geo:'RIB_dish_S' },
      L:{ price:12, fp:{w:126,d:84}, h:15.5, geo:'RIB_dish_L' }
    }
  },
  card:   { name:'RIB Card Slot',      price:9,   fp:{w:63,d:63},   h:15.5, geo:'RIB_card_slot' },
  jewel:  { name:'RIB Jewelry Holder', price:9,   fp:{w:40,d:63},   h:60.5, geo:'RIB_jewellery_holder' },
  note:   { name:'RIB Note Holder',    price:9,   fp:{w:83,d:84},   h:15.5, geo:'RIB_note_holder' },
  napkin: { name:'RIB Napkin Holder',  price:29,  fp:{w:131,d:126}, h:54,   geo:'RIB_napkin_holder' },
  timelight:{ name:'RIB Time + Light', price:125, fp:{w:103,d:64},  h:159.5, geo:'RIB_time_light' }
};

const DISCOUNT_THRESHOLD = 4;
const DISCOUNT_RATE = 0.15;

/* ---------------- STATE ---------------- */
const state = {
  base:'none',
  baseColour:DEFAULT_COLOUR,
  modules:[],
  coasters:[],
  coasterPos:null
};
let uidCounter = 0;
let lastColour = DEFAULT_COLOUR;

/* runtime-resolved variant ids:
   IDS.base[size][colour], IDS.piece[key][size?][colour],
   IDS.coaster[colour], IDS.root[size] */
const IDS = { base:{S:{},L:{}}, piece:{}, coaster:{}, root:{} };
let linkWarnings = [];

/* ---------------- HELPERS ---------------- */
const $ = id => document.getElementById(id);
const money = n => '$' + (Number.isInteger(n) ? n : n.toFixed(2));
const clamp = (v,lo,hi) => Math.max(lo, Math.min(hi, v));

function def(m){ return PIECES[m.key]; }
function variantOf(m){ return def(m).sizes ? def(m).sizes[m.size] : def(m); }
function priceOf(m){ return variantOf(m).price; }
function fpOf(m){ return variantOf(m).fp; }
function hOf(m){ return variantOf(m).h; }
function geoOf(m){ return variantOf(m).geo; }
function surface(){ return BASES[state.base]; }

function snapY(y, d){
  const s = surface();
  const maxY = s.d - d;
  if(!s.snap) return clamp(y, 0, maxY);
  const snapped = Math.round(y / PITCH) * PITCH;
  return clamp(Math.min(snapped, Math.floor(maxY / PITCH) * PITCH), 0, maxY);
}

function rects(ignore){
  const list = [];
  for(const m of state.modules){
    if(ignore === m.uid) continue;
    const f = fpOf(m);
    list.push({ x:m.x, y:m.y, w:f.w, d:f.d });
  }
  if(state.coasterPos && ignore !== 'stack'){
    list.push({ x:state.coasterPos.x, y:state.coasterPos.y,
                w:COASTER.fp.w, d:COASTER.fp.d });
  }
  return list;
}

function collides(x, y, w, d, ignore){
  for(const r of rects(ignore)){
    if(x < r.x + r.w - 1 && x + w > r.x + 1 &&
       y < r.y + r.d - 1 && y + d > r.y + 1) return true;
  }
  return false;
}

function findSpot(w, d, ignore){
  const s = surface();
  if(w > s.w || d > s.d) return null;
  const yStep = s.snap ? PITCH : 6;
  for(let y = 0; y <= s.d - d; y += yStep){
    for(let x = 0; x <= s.w - w; x += 4){
      if(!collides(x, y, w, d, ignore)) return {x, y};
    }
  }
  return null;
}

function totals(){
  let subtotal = 0, count = 0;
  if(state.base !== 'none'){ subtotal += surface().price; count++; }
  for(const m of state.modules){
    subtotal += priceOf(m); count++;
    if(m.root){ subtotal += ROOT[m.size].price; count++; }
  }
  for(const c of state.coasters){ subtotal += COASTER.price; count++; }
  const discount = count >= DISCOUNT_THRESHOLD ? subtotal * DISCOUNT_RATE : 0;
  return { subtotal, discount, total:subtotal - discount, count };
}

/* ---------------- PRODUCT RESOLUTION ---------------- */
const SIZE_ALIASES = {
  S:['s','small'], M:['m','medium'], L:['l','large']
};

const productCache = {};
function fetchProduct(handle){
  if(!productCache[handle]){
    productCache[handle] = fetch('/products/' + handle + '.js')
      .then(r => { if(!r.ok) throw new Error('not found'); return r.json(); });
  }
  return productCache[handle];
}

function optionIndexes(product){
  const names = product.options.map(o =>
    (typeof o === 'string' ? o : o.name).toLowerCase());
  return {
    size: names.findIndex(n => n.includes('size')),
    colour: names.findIndex(n => n.includes('colour') || n.includes('color'))
  };
}

function matchVariant(product, idx, size, colour){
  return product.variants.find(v => {
    /* accessory variants (e.g. a pad or refill on a product) are
       not configurator items and must never match as colourways */
    if(/pad|grid|refill/i.test(
      [v.title, v.option1, v.option2, v.option3].join(' '))) return false;
    const opts = [v.option1, v.option2, v.option3]
      .map(x => (x || '').toLowerCase().trim());
    const sizeOk = size == null || idx.size === -1 ||
      SIZE_ALIASES[size].includes(opts[idx.size]);
    const colOk = colour == null || idx.colour === -1 ||
      opts[idx.colour].includes(colour);
    return sizeOk && colOk;
  });
}

async function resolveProducts(){
  const h = CFG.handles || {};
  const colours = Object.keys(COLOURWAYS);

  async function resolve(handle, label, fill){
    if(!handle){ linkWarnings.push(label + ': no product assigned'); return; }
    let p;
    try{ p = await fetchProduct(handle); }
    catch(e){ linkWarnings.push(label + ': product "' + handle + '" not found'); return; }
    fill(p, optionIndexes(p));
  }

  const jobs = [];

  jobs.push(resolve(h.base, 'RIB Base', (p, idx) => {
    for(const sz of ['S','L']){
      for(const c of colours){
        const v = matchVariant(p, idx, sz, c);
        if(v){ IDS.base[sz][c] = v.id; BASES[sz].price = v.price / 100; }
        else linkWarnings.push('RIB Base ' + sz + ' ' + c + ': no matching variant');
      }
    }
  }));

  for(const [key, d] of Object.entries(PIECES)){
    jobs.push(resolve(h[key], d.name, (p, idx) => {
      IDS.piece[key] = {};
      if(d.sizes){
        for(const sz of Object.keys(d.sizes)){
          IDS.piece[key][sz] = {};
          for(const c of colours){
            const v = matchVariant(p, idx, sz, c);
            if(v){ IDS.piece[key][sz][c] = v.id; d.sizes[sz].price = v.price / 100; }
            else linkWarnings.push(d.name + ' ' + sz + ' ' + c + ': no matching variant');
          }
        }
      } else {
        for(const c of colours){
          const v = matchVariant(p, idx, null, c);
          if(v){ IDS.piece[key][c] = v.id; d.price = v.price / 100; }
          else linkWarnings.push(d.name + ' ' + c + ': no matching variant');
        }
      }
    }));
  }

  jobs.push(resolve(h.coaster, 'RIB Coaster', (p, idx) => {
    for(const c of colours){
      const v = matchVariant(p, idx, null, c);
      if(v){ IDS.coaster[c] = v.id; COASTER.price = v.price / 100; }
      else linkWarnings.push('RIB Coaster ' + c + ': no matching variant');
    }
  }));

  jobs.push(resolve(h.root, 'RIB Root', (p, idx) => {
    for(const sz of ['S','M','L']){
      const v = matchVariant(p, idx, sz, null);
      if(v){ IDS.root[sz] = v.id; ROOT[sz].price = v.price / 100; }
      else linkWarnings.push('RIB Root ' + sz + ': no matching variant');
    }
  }));

  await Promise.all(jobs);

  if(linkWarnings.length){
    console.warn('RIB configurator, unlinked variants:\n' + linkWarnings.join('\n'));
    const note = document.createElement('p');
    note.className = 'discount-note';
    note.style.color = '#8a5a3a';
    note.textContent = 'Setup note (visible until resolved): ' +
      linkWarnings.length + ' variant link' +
      (linkWarnings.length === 1 ? '' : 's') +
      ' missing. Details in the browser console.';
    document.querySelector('#rib-configurator .summary').appendChild(note);
  }
}

/* ---------------- THREE ---------------- */
let renderer, scene, camera, itemsGroup, surfaceOutline = null;
const GEO = {};
const MATS = {};
let GEOMETRY_DATA = null;
const meshByTag = new Map();
const canvas = $('view');

function initThree(){
  renderer = new THREE.WebGLRenderer({ canvas, antialias:true, alpha:false });
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  renderer.shadowMap.enabled = true;
  renderer.shadowMap.type = THREE.PCFSoftShadowMap;
  renderer.outputEncoding = THREE.sRGBEncoding;

  scene = new THREE.Scene();
  scene.background = new THREE.Color(0xF5F4F1).convertSRGBToLinear();

  camera = new THREE.OrthographicCamera(-1, 1, 1, -1, -1000, 3000);

  scene.add(new THREE.HemisphereLight(0xffffff, 0xC9C4BB, 0.62));
  const sun = new THREE.DirectionalLight(0xfff6ec, 0.55);
  sun.position.set(180, 420, 260);
  sun.castShadow = true;
  sun.shadow.mapSize.set(2048, 2048);
  sun.shadow.camera.left = -320; sun.shadow.camera.right = 320;
  sun.shadow.camera.top = 320;   sun.shadow.camera.bottom = -320;
  sun.shadow.camera.far = 1200;
  sun.shadow.bias = -0.0004;
  scene.add(sun);

  const ground = new THREE.Mesh(
    new THREE.PlaneGeometry(1600, 1600),
    new THREE.ShadowMaterial({ opacity:0.12 }));
  ground.rotation.x = -Math.PI / 2;
  ground.receiveShadow = true;
  scene.add(ground);

  for(const [name, g] of Object.entries(GEOMETRY_DATA)){
    const geom = new THREE.BufferGeometry();
    geom.setAttribute('position',
      new THREE.Float32BufferAttribute(new Float32Array(g.p), 3));
    geom.setIndex(g.i);
    geom.computeVertexNormals();
    GEO[name] = geom;
  }

  itemsGroup = new THREE.Group();
  scene.add(itemsGroup);
}

function mat(key){
  if(!MATS[key]){
    MATS[key] = new THREE.MeshStandardMaterial({
      color: key === 'root' ? ROOT_HEX : COLOURWAYS[key].hex,
      /* near-black matte returns no shading variation, so the root
         carries a slight sheen to keep its internal depth legible */
      roughness: key === 'root' ? 0.72 : 0.94,
      metalness: 0.0, flatShading: true,
      side: THREE.DoubleSide, transparent: false, opacity: 1
    });
    /* input hexes are sRGB swatches; convert so the sRGB output
       pass returns the exact swatch colour */
    MATS[key].color.convertSRGBToLinear();
  }
  return MATS[key];
}

function makeOutline(w, d){
  const pts = [
    new THREE.Vector3(0,0.3,0), new THREE.Vector3(w,0.3,0),
    new THREE.Vector3(w,0.3,d), new THREE.Vector3(0,0.3,d),
    new THREE.Vector3(0,0.3,0)
  ];
  const geo = new THREE.BufferGeometry().setFromPoints(pts);
  const line = new THREE.Line(geo,
    new THREE.LineDashedMaterial({ color:0xB8B4AC, dashSize:6, gapSize:7 }));
  line.computeLineDistances();
  return line;
}

function geoHeight(name){ return GEOMETRY_DATA[name].size[2]; }

function disposeChildren(group){
  while(group.children.length){
    const c = group.children.pop();
    c.traverse(o => {
      if(o.geometry && !Object.values(GEO).includes(o.geometry)) o.geometry.dispose();
    });
  }
}

function rebuildScene(){
  disposeChildren(itemsGroup);
  meshByTag.clear();
  if(surfaceOutline){ scene.remove(surfaceOutline); surfaceOutline = null; }

  const s = surface();
  const hasBase = state.base !== 'none';
  const z0 = zSeat();

  if(hasBase){
    const b = new THREE.Mesh(GEO[s.geo], mat(state.baseColour));
    b.castShadow = true; b.receiveShadow = true;
    itemsGroup.add(b);
  } else {
    surfaceOutline = makeOutline(s.w, s.d);
    scene.add(surfaceOutline);
  }

  for(const m of state.modules){
    const g = new THREE.Group();
    const mesh = new THREE.Mesh(GEO[geoOf(m)], mat(m.colour));
    mesh.castShadow = true; mesh.receiveShadow = true;
    g.add(mesh);
    if(m.root){
      const r = ROOT[m.size];
      const rm = new THREE.Mesh(GEO[r.geo], mat('root'));
      rm.castShadow = false; rm.receiveShadow = true;
      /* root is 64 wide against the 63 cup, centred; its 2mm rim
         sits over the cup's top edge */
      rm.position.set(-0.5, hOf(m) - geoHeight(r.geo) + 2, -0.5);
      g.add(rm);
    }
    g.position.set(m.x, z0, m.y);
    g.traverse(o => o.userData.tag = 'm' + m.uid);
    meshByTag.set('m' + m.uid, g);
    itemsGroup.add(g);
  }

  if(state.coasterPos && state.coasters.length){
    const g = new THREE.Group();
    state.coasters.forEach((c, i) => {
      const cm = new THREE.Mesh(GEO[COASTER.geo], mat(c.colour));
      cm.castShadow = true; cm.receiveShadow = true;
      cm.position.y = i * COASTER_RISE;
      g.add(cm);
    });
    g.position.set(state.coasterPos.x, z0, state.coasterPos.y);
    g.traverse(o => o.userData.tag = 'stack');
    meshByTag.set('stack', g);
    itemsGroup.add(g);
  }

  frameCamera();
  render();
}

function syncPositions(){
  const z0 = zSeat();
  for(const m of state.modules){
    const g = meshByTag.get('m' + m.uid);
    if(g) g.position.set(m.x, z0, m.y);
  }
  if(state.coasterPos){
    const g = meshByTag.get('stack');
    if(g) g.position.set(state.coasterPos.x, z0, state.coasterPos.y);
  }
  render();
}

function frameCamera(){
  const s = surface();
  const cx = s.w / 2, cz = s.d / 2;
  const dist = 900;
  camera.position.set(cx + dist * 0.62, dist * 0.58, cz + dist * 0.62);
  camera.lookAt(cx, 34, cz);
  camera.updateProjectionMatrix();
}

function resize(){
  if(!renderer) return;
  const w = canvas.clientWidth || 660;
  const h = canvas.clientHeight || Math.round(w * 440 / 660);
  renderer.setSize(w, h, false);
  const halfW = 265;
  const halfH = halfW * h / w;
  camera.left = -halfW; camera.right = halfW;
  camera.top = halfH;   camera.bottom = -halfH;
  camera.updateProjectionMatrix();
  render();
}
window.addEventListener('resize', resize);

function render(){ if(renderer) renderer.render(scene, camera); }

/* ---------------- DRAG ---------------- */
const raycaster = new THREE.Raycaster ? new THREE.Raycaster() : null;
let pointerV, dragPlane, hitV, drag = null;

function initDrag(){
  pointerV = new THREE.Vector2();
  dragPlane = new THREE.Plane(new THREE.Vector3(0,1,0), 0);
  hitV = new THREE.Vector3();

  function setPointer(evt){
    const r = canvas.getBoundingClientRect();
    pointerV.x = ((evt.clientX - r.left) / r.width) * 2 - 1;
    pointerV.y = -((evt.clientY - r.top) / r.height) * 2 + 1;
  }

  canvas.addEventListener('pointerdown', evt => {
    setPointer(evt);
    raycaster.setFromCamera(pointerV, camera);
    const hits = raycaster.intersectObjects(itemsGroup.children, true);
    const found = hits.find(h => h.object.userData.tag);
    if(!found) return;
    const tag = found.object.userData.tag;

    dragPlane.constant = -zSeat();
    if(!raycaster.ray.intersectPlane(dragPlane, hitV)) return;

    if(tag === 'stack'){
      drag = { stack:true, offX: hitV.x - state.coasterPos.x,
               offY: hitV.z - state.coasterPos.y };
    } else {
      const uid = Number(tag.slice(1));
      const m = state.modules.find(x => x.uid === uid);
      if(!m) return;
      drag = { m, offX: hitV.x - m.x, offY: hitV.z - m.y };
    }
    canvas.setPointerCapture(evt.pointerId);
    canvas.style.cursor = 'grabbing';
    evt.preventDefault();
  });

  canvas.addEventListener('pointermove', evt => {
    if(!drag) return;
    setPointer(evt);
    raycaster.setFromCamera(pointerV, camera);
    if(!raycaster.ray.intersectPlane(dragPlane, hitV)) return;

    const s = surface();
    const f = drag.stack ? COASTER.fp : fpOf(drag.m);
    const ignore = drag.stack ? 'stack' : drag.m.uid;
    const target = drag.stack ? state.coasterPos : drag.m;

    const nx = clamp(hitV.x - drag.offX, 0, s.w - f.w);
    const ny = snapY(hitV.z - drag.offY, f.d);

    if(!collides(nx, ny, f.w, f.d, ignore)){
      target.x = nx; target.y = ny;
    } else if(!collides(nx, target.y, f.w, f.d, ignore)){
      target.x = nx;
    } else if(!collides(target.x, ny, f.w, f.d, ignore)){
      target.y = ny;
    }
    syncPositions();
  });

  canvas.addEventListener('pointerup', () => {
    drag = null;
    canvas.style.cursor = 'grab';
  });
}

/* ---------------- CONTROLS ---------------- */
function refit(){
  let dropped = 0;
  const kept = [];
  const s = surface();
  for(const m of state.modules){
    const f = fpOf(m);
    if(f.w > s.w || f.d > s.d){ dropped++; continue; }
    m.x = clamp(m.x, 0, s.w - f.w);
    m.y = snapY(m.y, f.d);
    if(collides(m.x, m.y, f.w, f.d, m.uid)){
      const spot = findSpot(f.w, f.d, m.uid);
      if(spot){ m.x = spot.x; m.y = spot.y; kept.push(m); }
      else dropped++;
    } else kept.push(m);
  }
  state.modules = kept;

  if(state.coasterPos){
    const f = COASTER.fp;
    if(f.w > s.w || f.d > s.d){
      dropped += state.coasters.length;
      state.coasters = []; state.coasterPos = null;
    } else {
      state.coasterPos.x = clamp(state.coasterPos.x, 0, s.w - f.w);
      state.coasterPos.y = snapY(state.coasterPos.y, f.d);
      if(collides(state.coasterPos.x, state.coasterPos.y, f.w, f.d, 'stack')){
        const spot = findSpot(f.w, f.d, 'stack');
        if(spot){ state.coasterPos = spot; }
        else { dropped += state.coasters.length;
               state.coasters = []; state.coasterPos = null; }
      }
    }
  }
  if(dropped > 0){
    $('paletteMsg').textContent = dropped === 1
      ? 'One piece did not fit and was removed.'
      : dropped + ' pieces did not fit and were removed.';
  }
}

function renderBaseOptions(){
  const wrap = $('baseOptions');
  wrap.innerHTML = '';
  for(const [key,b] of Object.entries(BASES)){
    const btn = document.createElement('button');
    btn.className = 'base-btn';
    btn.setAttribute('aria-pressed', state.base === key);
    const sub = key === 'none' ? b.sub : b.sub + ' · ' + money(b.price);
    btn.innerHTML = b.label + '<small>' + sub + '</small>';
    btn.onclick = () => { state.base = key; refit(); renderAll(); };
    wrap.appendChild(btn);
  }
}

function renderPalette(){
  const wrap = $('palette');
  wrap.innerHTML = '';

  for(const [key,d] of Object.entries(PIECES)){
    const btn = document.createElement('button');
    btn.className = 'piece-btn';
    const priceLabel = d.sizes
      ? 'from ' + money(Math.min(...Object.values(d.sizes).map(v => v.price)))
      : money(d.price);
    btn.innerHTML = '<span>' + d.name + '</span><span class="from">' + priceLabel + '</span>';
    btn.onclick = () => {
      const firstSize = d.sizes ? Object.keys(d.sizes)[0] : null;
      const fp = d.sizes ? d.sizes[firstSize].fp : d.fp;
      const spot = findSpot(fp.w, fp.d, -1);
      if(!spot){
        $('paletteMsg').textContent =
          'No room left for this piece. Move something, remove a piece, or choose the large base.';
        return;
      }
      $('paletteMsg').textContent = '';
      state.modules.push({
        uid:++uidCounter, key, size:firstSize, colour:lastColour,
        x:spot.x, y:spot.y, root:false
      });
      renderAll();
    };
    wrap.appendChild(btn);
  }

  const cbtn = document.createElement('button');
  cbtn.className = 'piece-btn';
  cbtn.innerHTML = '<span>' + COASTER.name + '</span><span class="from">' + money(COASTER.price) + '</span>';
  cbtn.onclick = () => {
    if(!state.coasterPos){
      const spot = findSpot(COASTER.fp.w, COASTER.fp.d, 'stack');
      if(!spot){
        $('paletteMsg').textContent =
          'No room left for a coaster. Move something, remove a piece, or choose the large base.';
        return;
      }
      state.coasterPos = spot;
    }
    $('paletteMsg').textContent = '';
    state.coasters.push({ uid:++uidCounter, colour:lastColour });
    renderAll();
  };
  wrap.appendChild(cbtn);
}

function renderSelected(){
  const wrap = $('selectedList');
  wrap.innerHTML = '';

  if(state.base !== 'none'){
    wrap.appendChild(selRow({
      name: surface().label,
      price: surface().price,
      colour: state.baseColour,
      onColour: c => { state.baseColour = c; lastColour = c; renderAll(); }
    }));
  }

  for(const m of state.modules){
    const d = def(m);
    wrap.appendChild(selRow({
      name: d.name,
      price: priceOf(m) + (m.root ? ROOT[m.size].price : 0),
      colour: m.colour,
      onColour: c => { m.colour = c; lastColour = c; renderAll(); },
      onRemove: () => {
        state.modules = state.modules.filter(x => x.uid !== m.uid);
        renderAll();
      },
      size: d.sizes ? {
        current: m.size,
        options: Object.keys(d.sizes),
        onPick: sz => {
          const prev = m.size;
          const fp = d.sizes[sz].fp;
          const s = surface();
          if(fp.w > s.w || fp.d > s.d){
            $('paletteMsg').textContent = 'That size is larger than this surface.';
            renderAll(); return;
          }
          const nx = clamp(m.x, 0, s.w - fp.w);
          const ny = snapY(m.y, fp.d);
          m.size = sz;
          if(!collides(nx, ny, fp.w, fp.d, m.uid)){
            m.x = nx; m.y = ny;
          } else {
            const spot = findSpot(fp.w, fp.d, m.uid);
            if(spot){ m.x = spot.x; m.y = spot.y; }
            else {
              m.size = prev;
              $('paletteMsg').textContent =
                'That size does not fit the current arrangement.';
            }
          }
          renderAll();
        }
      } : null,
      root: d.rootable ? {
        on: m.root,
        price: ROOT[m.size].price,
        onToggle: () => { m.root = !m.root; renderAll(); }
      } : null
    }));
  }

  state.coasters.forEach((c, i) => {
    wrap.appendChild(selRow({
      name: COASTER.name + (state.coasters.length > 1 ? ' · level ' + (i + 1) : ''),
      price: COASTER.price,
      colour: c.colour,
      onColour: col => { c.colour = col; lastColour = col; renderAll(); },
      onRemove: () => {
        state.coasters = state.coasters.filter(x => x.uid !== c.uid);
        if(state.coasters.length === 0) state.coasterPos = null;
        renderAll();
      }
    }));
  });
}

function selRow(cfg){
  const row = document.createElement('div');
  row.className = 'sel-row';

  const nm = document.createElement('span');
  nm.className = 'name';
  nm.textContent = cfg.name;
  row.appendChild(nm);

  if(cfg.size){
    const st = document.createElement('div');
    st.className = 'size-toggle';
    st.setAttribute('role','group');
    st.setAttribute('aria-label','Size');
    for(const s of cfg.size.options){
      const b = document.createElement('button');
      b.textContent = s;
      b.setAttribute('aria-pressed', s === cfg.size.current);
      b.onclick = () => cfg.size.onPick(s);
      st.appendChild(b);
    }
    row.appendChild(st);
  }

  if(cfg.root){
    const rt = document.createElement('button');
    rt.className = 'root-toggle';
    rt.textContent = cfg.root.on ? 'Root in' : 'Root +' + money(cfg.root.price);
    rt.setAttribute('aria-pressed', cfg.root.on);
    rt.title = 'RIB Root planter insert';
    rt.onclick = cfg.root.onToggle;
    row.appendChild(rt);
  }

  const sw = document.createElement('div');
  sw.className = 'swatches';
  sw.setAttribute('role','group');
  sw.setAttribute('aria-label','Colourway');
  for(const [ck,c] of Object.entries(COLOURWAYS)){
    const b = document.createElement('button');
    b.className = 'swatch';
    b.style.background = SWATCH_CSS[ck];
    b.title = c.label;
    b.setAttribute('aria-label', c.label);
    b.setAttribute('aria-pressed', ck === cfg.colour);
    b.onclick = () => cfg.onColour(ck);
    sw.appendChild(b);
  }
  row.appendChild(sw);

  const pr = document.createElement('span');
  pr.className = 'sel-price';
  pr.textContent = money(cfg.price);
  row.appendChild(pr);

  if(cfg.onRemove){
    const rm = document.createElement('button');
    rm.className = 'remove-btn';
    rm.innerHTML = '&times;';
    rm.setAttribute('aria-label','Remove ' + cfg.name);
    rm.onclick = cfg.onRemove;
    row.appendChild(rm);
  } else {
    const spacer = document.createElement('span');
    spacer.style.width = '24px';
    row.appendChild(spacer);
  }
  return row;
}

function renderSummary(){
  const t = totals();
  $('sumSubtotal').textContent = money(t.subtotal);
  $('sumTotal').textContent = money(t.total);
  const dl = $('discountLine');
  if(t.discount > 0){
    dl.style.display = 'flex';
    $('sumDiscount').textContent = '-' + money(t.discount);
    $('discountHint').textContent = 'The 15% comes off automatically at checkout.';
  } else {
    dl.style.display = 'none';
    $('discountHint').textContent =
      'Any four items and 15% comes off automatically at checkout.';
  }
  $('pieceCount').textContent = t.count + (t.count === 1 ? ' piece' : ' pieces');
  $('cartBtn').disabled = t.count === 0;
  disarmReset();
  const resetBtn = $('resetBtn');
  if(resetBtn) resetBtn.hidden = t.count === 0;
  $('dragHint').style.display =
    (state.modules.length || state.coasters.length) ? 'block' : 'none';
}

/* ---------------- CART ---------------- */
function buildCartPayload(){
  const items = [];
  if(state.base !== 'none'){
    items.push({
      id: IDS.base[state.base][state.baseColour], quantity:1,
      _debug: surface().label + ' · ' + COLOURWAYS[state.baseColour].label
    });
  }
  for(const m of state.modules){
    const d = def(m);
    const map = IDS.piece[m.key] || {};
    const id = d.sizes ? (map[m.size] || {})[m.colour] : map[m.colour];
    items.push({
      id, quantity:1,
      _debug: d.name + (m.size ? ' ' + m.size : '') + ' · ' + COLOURWAYS[m.colour].label
    });
    if(m.root){
      items.push({ id: IDS.root[m.size], quantity:1, _debug:'RIB Root ' + m.size });
    }
  }
  for(const c of state.coasters){
    items.push({
      id: IDS.coaster[c.colour], quantity:1,
      _debug: COASTER.name + ' · ' + COLOURWAYS[c.colour].label
    });
  }
  return items;
}

async function addToCart(){
  const items = buildCartPayload();

  if(!CFG.shopify){
    alert('Prototype mode. This would add:\n\n' +
      items.map(i => '· ' + i._debug).join('\n'));
    return;
  }

  const missing = items.filter(i => !i.id);
  if(missing.length){
    alert('Some pieces are still being connected to the store: ' +
      missing.map(i => i._debug).join(', ') +
      '. Please try again shortly.');
    return;
  }

  const btn = $('cartBtn');
  btn.disabled = true;
  btn.textContent = 'Adding';
  try{
    const res = await fetch('/cart/add.js', {
      method:'POST',
      headers:{ 'Content-Type':'application/json' },
      body: JSON.stringify({ items: items.map(({id,quantity}) => ({id,quantity})) })
    });
    if(!res.ok){
      const err = await res.json();
      throw new Error(err.description || 'One of the pieces could not be added.');
    }
    window.location.href = '/cart';
  } catch(e){
    alert(e.message + ' Nothing was charged. Adjust the arrangement and try again.');
    btn.disabled = false;
    btn.textContent = 'Add arrangement to cart';
  }
}

/* ---------------- PERMALINK ---------------- */
function b64uEncode(s){
  return btoa(unescape(encodeURIComponent(s)))
    .replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,'');
}
function b64uDecode(s){
  s = s.replace(/-/g,'+').replace(/_/g,'/');
  while(s.length % 4) s += '=';
  return decodeURIComponent(escape(atob(s)));
}

function serializeState(){
  return b64uEncode(JSON.stringify({
    b: state.base, bc: state.baseColour,
    m: state.modules.map(m =>
      [m.key, m.size, m.colour, Math.round(m.x), Math.round(m.y), m.root ? 1 : 0]),
    c: state.coasters.map(c => c.colour),
    cp: state.coasterPos ? [Math.round(state.coasterPos.x), Math.round(state.coasterPos.y)] : null
  }));
}

function applySerialized(str){
  let o;
  try{ o = JSON.parse(b64uDecode(str)); }catch(e){ return false; }
  if(!o || !BASES[o.b] || !COLOURWAYS[o.bc]) return false;
  state.base = o.b;
  state.baseColour = o.bc;
  state.modules = [];
  for(const row of (o.m || [])){
    const [key, size, colour, x, y, root] = row;
    const d = PIECES[key];
    if(!d || !COLOURWAYS[colour]) continue;
    if(d.sizes && !d.sizes[size]) continue;
    state.modules.push({
      uid:++uidCounter, key,
      size: d.sizes ? size : null,
      colour, x:Number(x) || 0, y:Number(y) || 0,
      root: !!root && !!d.rootable
    });
  }
  state.coasters = (o.c || [])
    .filter(col => COLOURWAYS[col])
    .map(col => ({ uid:++uidCounter, colour:col }));
  state.coasterPos = (state.coasters.length && o.cp)
    ? { x:Number(o.cp[0]) || 0, y:Number(o.cp[1]) || 0 } : null;
  if(state.coasters.length && !state.coasterPos) state.coasterPos = {x:0, y:0};
  refit();
  return true;
}

function updateHash(){
  const t = totals();
  const url = t.count === 0
    ? location.pathname + location.search
    : location.pathname + location.search + '#a=' + serializeState();
  history.replaceState(null, '', url);
}

function restoreState(){
  const m = location.hash.match(/#a=([A-Za-z0-9_-]+)/);
  if(m) applySerialized(m[1]);
}

/* saved links carry UTM parameters, so returning visits appear in
   Shopify analytics attributed to configurator / save */
function permalink(){
  return location.origin + location.pathname +
    '?utm_source=configurator&utm_medium=save' +
    '#a=' + serializeState();
}

function initKeep(){
  const copyBtn = $('copyLink'), mailBtn = $('mailLink');
  if(!copyBtn || !mailBtn) return;

  copyBtn.onclick = async () => {
    try{
      await navigator.clipboard.writeText(permalink());
      copyBtn.textContent = 'Link copied';
      setTimeout(() => { copyBtn.textContent = 'Copy link'; }, 2000);
    }catch(e){
      window.prompt('Copy this link', permalink());
    }
  };

  mailBtn.onclick = () => {
    const subject = encodeURIComponent('Your RIB arrangement');
    const body = encodeURIComponent(
      'Your RIB arrangement, saved to continue later:\n\n' + permalink());
    window.location.href = 'mailto:?subject=' + subject + '&body=' + body;
  };
}

/* ---------------- START OVER ---------------- */
let resetArmed = false, resetTimer = null;

function disarmReset(){
  if(!resetArmed) return;
  resetArmed = false;
  clearTimeout(resetTimer);
  const btn = $('resetBtn');
  if(btn) btn.textContent = 'Start over';
}

function resetAll(){
  state.base = 'none';
  state.baseColour = DEFAULT_COLOUR;
  state.modules = [];
  state.coasters = [];
  state.coasterPos = null;
  lastColour = DEFAULT_COLOUR;
  const msg = $('paletteMsg');
  if(msg) msg.textContent = '';
  renderAll();
}

function initReset(){
  const btn = $('resetBtn');
  if(!btn) return;
  btn.onclick = () => {
    /* two taps: clearing an arrangement should never be a slip */
    if(!resetArmed){
      resetArmed = true;
      btn.textContent = 'Tap again to clear';
      clearTimeout(resetTimer);
      resetTimer = setTimeout(disarmReset, 4000);
      return;
    }
    disarmReset();
    resetAll();
  };
}

/* ---------------- INIT ---------------- */
function renderAll(){
  renderBaseOptions();
  renderPalette();
  renderSelected();
  renderSummary();
  rebuildScene();
  updateHash();
}

async function boot(){
  if(typeof THREE === 'undefined'){
    $('pieceCount').textContent = 'Viewer unavailable';
    return;
  }
  try{
    const res = await fetch(rootEl.dataset.geometryUrl);
    GEOMETRY_DATA = await res.json();
  } catch(e){
    $('pieceCount').textContent = 'Could not load pieces';
    return;
  }
  initThree();
  initDrag();
  if(CFG.shopify){
    try{ await resolveProducts(); }
    catch(e){ console.warn('RIB configurator resolution error', e); }
  }
  restoreState();
  initKeep();
  initReset();
  $('cartBtn').onclick = addToCart;
  resize();
  renderAll();
}

if(document.readyState === 'loading'){
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}

})();
